export default __webpack_public_path__ + "static/media/music-player.79bc8f97.png";